export enum SlabTypes {
    Multi = 'multi',
    Single = 'single',
}
